/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  var locations = [];
  var locationsFull;
  var locationCodes = [];
  var selectedLocation;

  $(".form :input").change(function () {
    if (!window.gf_form_conditional_logic) {
      return;
    }
    var choice_ids = $(this).attr("id").split("_");
    var form_id = $('[id^="form-"]').attr("id").split("-")[1];
    var field_id = choice_ids[2];

    var dependentFieldIds = rgars(
      gf_form_conditional_logic,
      [form_id, "fields", gformExtractFieldId(choice_ids[2])].join("/")
    );

    var formConditionalLogic = rgars(
      window,
      "gf_form_conditional_logic/" + form_id
    );

    for (var i = 0; i < dependentFieldIds.length; i++) {
      var conditionalLogic = rgars(
        formConditionalLogic,
        "logic/" + dependentFieldIds[i]
      );

      var show = false;

      for (
        let index = 0;
        index < conditionalLogic.field.rules.length;
        index++
      ) {
        const rule = conditionalLogic.field.rules[index];
        if (
          $(
            '[id^="choice_' +
              form_id +
              "_" +
              rule.fieldId +
              '_"][value="' +
              rule.value +
              '"]'
          ).is(":checked")
        ) {
          show = true;
          if (conditionalLogic.field.logicType === "any") {
            break;
          }
        } else {
          show = false;
          if (conditionalLogic.field.logicType === "all") {
            break;
          }
        }
      }

      if (show) {
        $("#field-" + dependentFieldIds[i]).removeClass("hide");
      } else {
        $("#field-" + dependentFieldIds[i]).addClass("hide");
      }
    }
  });

  //Buttons Events Interactions
  $(".next-page").click(function (event) {
    var goToNext = true;
    var emailValidate = true;
    if ($(".page.active .required:not(span):not(.hide)").length === 0) {
      goToNext = true;
    } else {
      var elements = $(".page.active .required:not(span):not(.hide)").find(
        "input, textarea, select"
      );
      $.each(elements, function (index, element) {
        if (
          element.type === "email" &&
          ($(element).val() === "" || !validateEmail($(element).val()))
        ) {
          emailValidate = false;
          goToNext = false;
          return false;
        }
        if (
          (element.type === "text" || element.type === "textarea") &&
          $(element).val() === ""
        ) {
          goToNext = false;
          return false;
        }
        if (
          element.type === "radio" &&
          $("input[name=" + element.name + "]:checked").length === 0
        ) {
          goToNext = false;
          return false;
        }
        if (element.type === "checkbox") {
          var min = 1;
          if ($(element).data("min") > 1) {
            min = $(element).data("min");
          }
          var sw = element.name.split("_");
          if (
            $("input[name^=" + sw[0] + "_" + sw[1] + "_]:checked").length < min
          ) {
            goToNext = false;
            return false;
          }
        }
      });
    }
    if (goToNext) {
      $(".page.active .error").addClass("hide");
      moveDown();
    } else {
      if (!emailValidate) {
        $(".page.active .error").html(
          "Bitte geben Sie eine gültige E-Mail-Adresse an."
        );
        $(".page.active .error").removeClass("hide");
      } else {
        $(".page.active .error").html(
          "Beantworten Sie alle Pflichtfragen, um fortzufahren."
        );
        $(".page.active .error").removeClass("hide");
      }
    }
  });

  $(".dots").click(function (event) {
    moveUp();
  });

  $(".more-information .btn-more-information").click(function (event) {
    var $info = $(this).next(".information");

    if ($(this).hasClass("closed")) {
      $(this).removeClass("closed").addClass("open");
      $(this).html("Informationen ausblenden");
      $info.slideDown();
    } else {
      $(this).removeClass("open").addClass("closed");
      $(this).html("Mehr Information");
      $info.slideUp();
    }
  });

  $(".condicional").each(function (index, element) {
    $(this).change(function (event) {
      if ($(element).is(":checked")) {
        $(element)
          .parent()
          .children(".input-h")
          .children("textarea")
          .prop("disabled", false);
        refreshPage();
      } else {
        $(element)
          .parent()
          .children(".input-h")
          .children("textarea")
          .prop("disabled", true);
        $(element).parent().children(".input-h").children("textarea").val("");
        refreshPage();
      }
    });
  });

  $(".hover-chk").each(function (index, element) {
    $(this).change(function (event) {
      if ($(element).is(":checked")) {
        $("#card-" + $(element).data("id-key")).css(
          "border",
          "3px solid #215aa7"
        );
        $("#title-" + $(element).data("id-key")).css("color", "#215AA7");
      } else {
        $("#card-" + $(element).data("id-key")).css({
          "background-color": "#FFFFFF",
          border: "transparent",
        });
        $("#title-" + $(element).data("id-key")).css("color", "#000000");
      }
    });
  });

  $(".disabled-chk").each(function (index, element) {
    var $beforeElement = $(element).parent().prev().children(".uk-checkbox");

    $beforeElement.change(function (event) {
      if ($beforeElement.is(":checked")) {
        $(element).parent().slideDown(refreshPage());
      } else {
        $(element).parent().slideUp(refreshPage());

        if ($(element).is(":checked")) {
          $(element).prop("checked", false);
        }
      }
    });
  });

  $(".countinput").each(function (index, element) {
    $(this).keyup(function () {
      $(element)
        .parent()
        .children(".count-val")
        .children("#char-count")
        .html(element.value.length);
    });
  });

  //functions
  //buttonsMove

  function moveDown( submitted = false ) {
    var $active = $(".active");
    var $nextPage = $active.next(".page");

    var $selectedDot = $("ul.selector li.selected");

    if ($nextPage.hasClass("last")) {
      $("html, body").animate({ scrollTop: 304 }, "slow");
    } else {
      $("html, body").animate({ scrollTop: 120 }, "slow");
    }

    $active.fadeOut(400, function () {
      refreshPage();
      $active.removeClass("active");
      $nextPage.addClass("active");
      refreshPage();
      $nextPage.fadeIn(400, function () {
        refreshPage();
      });
    });

    if ($nextPage.data("page-num") > 0) {
      if ($("#page-count").hasClass("uk-hidden")) {
        if (!$nextPage.hasClass("last")) {
          $("#page-count").removeClass("uk-hidden");
        }
      }
      if ($nextPage.data("page-num") > 1) {
        $(".dots").fadeIn();
        if ($nextPage.hasClass("last")) {
          $(".dots").fadeOut();
        }
      }
      $("span.page-num").html($nextPage.data("page-num"));
    }
    refreshPage();

    const data = {
      event: "change_survey_page",
      survey: main.survey_title,
      page: $nextPage.data("page-num"),
      submitted: submitted,
    }

    dataLayer.push(data);

  }

  function moveUp() {
    var $active = $(".active");
    var $prevPage = $active.prev(".page");

    $("html, body").animate({ scrollTop: 120 }, "slow");

    $active.fadeOut(400, function () {
      refreshPage();
      $active.removeClass("active");
      $prevPage.addClass("active");
      refreshPage();
      $prevPage.fadeIn(400, function () {
        refreshPage();
      });
    });

    if ($prevPage.data("page-num") > 0) {
      if ($prevPage.data("page-num") == 1) {
        $(".dots").fadeOut();
      }

      $("span.page-num").html($prevPage.data("page-num"));
    }
  }

  function changeBgColor() {
    if (
      document.querySelector(".active").attributes["data-page-num"].value == 0
    ) {
      $("header").addClass("change-header");
    } else {
      $("header").removeClass("change-header");
    }
  }

  changeBgColor();
  function refreshPage() {
    changeBgColor();
    $(window).trigger("resize").trigger("scroll");
  }
  //form submitions

  $(".page").each(function (index, page) {
    if (
      $(page).data("page-num") !== 0 &&
      $(page).data("page-num") !== $(".page").length - 1
    ) {
      var $this = $(this);
      var elements = $(this).find(
        "input, textarea, select, button, .add-choice"
      );
      var $choice;
      var $button;
      var numSelect = 0;
      $.each(elements, function (index, element) {
        if (
          element.localName === "span" &&
          element.className === "add-choice"
        ) {
          $choice = $(element);
        }

        if (element.localName === "button") {
          $button = $(element);
        }

        if (
          element.localName === "input" &&
          element.type === "checkbox" &&
          $(element).hasClass("disabled-chk") === false
        ) {
          $(element).change(function () {
            if ($(element).hasClass("last_choice")) {
              if ($(element).is(":checked")) {
                $this
                  .find("input:checkbox:checked:not(.last_choice)")
                  .prop("checked", false);
                $this
                  .find("input:checkbox:not(.last_choice)")
                  .prop("disabled", true);
                $this
                  .find(".main-card:not(.last)")
                  .css("background-color", "#fff");
                $this
                  .find(".main-card:not(.last)")
                  .children(".info-title")
                  .css("color", "#1E4588");
                // $button.prop("disabled", false);
                return;
              } else {
                numSelect = 1;
              }
            }

            if ($(element).hasClass("condicional")) {
              var $condicional = $(element);
              var $input = $condicional
                .parent()
                .children(".input-h")
                .children("textarea");
            }

            if ($(element).data("max") && $(element).data("min")) {
              numSelect = $(element)
                .closest(".form")
                .find("input:checkbox:checked").length;
              if ($(element).is(":checked")) {
                if (numSelect <= $(element).data("max")) {
                  $choice.html(numSelect);
                }

                if (numSelect == $(element).data("max")) {
                  $choice.css("color", "red");
                  $(element)
                    .closest(".form")
                    .find("input:checkbox:not(:checked):not(.disabled-chk)")
                    .prop("disabled", true);
                }
              } else {
                $this
                  .find("input:checkbox:not(:checked)")
                  .prop("disabled", false);
                $choice.html(numSelect);
                if (numSelect < $(element).data("max")) {
                  $choice.css("color", "initial");
                }
              }
              if (
                numSelect >= $(element).data("min") &&
                numSelect <= $(element).data("max")
              ) {
                if ($(element).hasClass("condicional")) {
                  if ($(element).is(":checked")) {
                    // $button.prop("disabled", true);

                    $input.keyup(function () {
                      if (
                        $input.val().length > 0 &&
                        numSelect >= $(element).data("min") &&
                        numSelect <= $(element).data("max")
                      ) {
                        $button.prop("disabled", false);
                      } else {
                        $button.prop("disabled", true);
                      }
                    });
                  } else {
                    if (
                      $condicional &&
                      $condicional.is(":checked") &&
                      $input.val().length == 0
                    ) {
                      // $button.prop("disabled", true);
                    } else {
                      if (
                        numSelect >= $(element).data("min") &&
                        numSelect <= $(element).data("max")
                      ) {
                        // $button.removeAttr("disabled");
                      } else {
                        // $button.prop("disabled", true);
                      }
                    }
                  }
                } else {
                  if (
                    $condicional &&
                    $condicional.is(":checked") &&
                    $input.val().length == 0
                  ) {
                    // $button.prop("disabled", true);
                  } else {
                    // $button.removeAttr("disabled");
                  }
                }
              }

              if (
                numSelect < $(element).data("min") ||
                numSelect > $(element).data("max")
              ) {
                // $button.prop("disabled", true);
              }
            }
          });
        }

        if (element.localName === "input" && element.type === "radio") {
          $(element).change(function () {
            if ($(element).is(":checked")) {
              // $button.removeAttr("disabled");
            }
          });
        }

        if (element.localName === "select") {
          var button = $(element).parent().parent().next().children("button");
          $(element).change(function () {
            if ($(this).val() != 0) {
              // button.removeAttr("disabled");
            } else {
              // button.prop("disabled", true);
            }
          });
        }

        if (element.localName === "textarea" || element.localName === "input") {
          $(element).keyup(function () {
            if (
              $(element).val().length > 0 &&
              !$(element).parent().hasClass("input-h")
            ) {
              // $button.removeAttr("disabled");
            } else {
              // $button.prop("disabled", true);
            }
          });
        }
      });
    }
    if ($(page).data("page-num") === $(".page").length - 1) {
      $("#input_1005").keyup(function () {
        if ($("#input_1002").is(":checked")) {
          if (!validateEmail($(this).val())) {
            $(".sendForm").prop("disabled", true);
          }
          if (validateEmail($(this).val()) && $("#input_1008").is(":checked")) {
            $(".sendForm").removeAttr("disabled");
          }
        } else {
          if ($(this).val().length == 0) {
            $(".sendForm").prop("disabled", false);
          }
          if ($(this).val().length > 0 && !validateEmail($(this).val())) {
            $(".sendForm").prop("disabled", true);
          }
          if (
            $(this).val().length > 0 &&
            validateEmail($(this).val()) &&
            $("#input_1008").is(":checked")
          ) {
            $(".sendForm").removeAttr("disabled");
          }
          if (
            $(this).val().length > 0 &&
            validateEmail($(this).val()) &&
            $("#input_1008").is(":not(:checked)")
          ) {
            $(".sendForm").prop("disabled", true);
          }
        }
      });
      $("#input_1008").change(function () {
        if (
          $(this).is(":checked") &&
          $("#input_1002").is(":checked") &&
          validateEmail($("#input_1005").val())
        ) {
          $(".sendForm").removeAttr("disabled");
        }
        if (
          $(this).is(":checked") &&
          $("#input_1002").is(":checked") &&
          !validateEmail($("#input_1005").val())
        ) {
          $(".sendForm").prop("disabled", true);
        }
        if ($(this).is(":not(:checked)") && $("#input_1002").is(":checked")) {
          $(".sendForm").prop("disabled", true);
        }

        if (
          $("#input_1002").is(":not(:checked)") &&
          $("#input_1005").val().length > 0 &&
          validateEmail($("#input_1005").val()) &&
          $(this).is(":checked")
        ) {
          $(".sendForm").removeAttr("disabled");
        }

        if (
          $("#input_1002").is(":not(:checked)") &&
          $("#input_1005").val().length > 0 &&
          !validateEmail($("#input_1005").val()) &&
          $(this).is(":checked")
        ) {
          $(".sendForm").prop("disabled", true);
        }

        if (
          $("#input_1002").is(":not(:checked)") &&
          $("#input_1005").val().length > 0 &&
          $(this).is(":not(:checked)")
        ) {
          $(".sendForm").prop("disabled", true);
        }
      });
    }
  });

  function validateEmail(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.toLowerCase());
  }

  function getLocationsCodes(termName) {
    var call = $.ajax({
      url: main.ajax_url,
      type: "post",
      data: {
        action: "get_locations",
        term_name: termName,
      },
      success: function (data) {
        locationCodes = data;
      },
    });
    return call;
  }

  $("#input_1000").change(function (e) {
    $("#codesBTN").prop("disabled", true);
    $(".code input").val("");
    $("#input_1002").prop("checked", false);
    if ($(this).val() != 1000) {
      getLocationsCodes($(this).val()).done(function () {
        $(".code-input").slideDown(function () {
          $("html, body").animate(
            { scrollTop: $(".code-input").offset().top - 50 },
            1000
          );
        });
      });
    } else {
      $("#codesBTN").prop("disabled", true);
      $(".code-input").slideUp(function () {
        $("html, body").animate({ scrollTop: 120 }, 1000);
      });
    }
  });

  $(".code input").keyup(function () {
    if (this.value.length > 5) {
      this.value = this.value.slice(0, 5);
    }

    if (
      this.value.length === 5 &&
      $("#location").val() !== 1000 &&
      verifyNumber()
    ) {
      $("#codesBTN").attr("disabled", false);
    } else {
      if (!$("#input_1002").is(":checked")) {
        $("#codesBTN").attr("disabled", true);
      }
    }
  });

  $("#input_1002").change(function (index, element) {
    if ($(this).is(":checked")) {
      $(".sendForm").prop("disabled", true);
      $("#codesBTN").attr("disabled", false);
    } else {
      $(".sendForm").prop("disabled", false);
      if (!verifyNumber()) {
        $("#codesBTN").attr("disabled", true);
      }
    }
  });

  function verifyNumber() {
    var number = $(".code input").val();
    if (number === "") {
      number = 0;
    }
    if (locationCodes.indexOf(number) >= 0) {
      return true;
    } else {
      return false;
    }
  }

  $(".card").each(function (index, element) {
    var $this = $(this);
    $this.hover(
      function (event) {
        $this.find(".info-hover").css("display", "block");
      },
      function () {
        $this.find(".info-hover").css("display", "none");
      }
    );
  });

  var response;

  $(".goToStart").click(function (event) {
    location.href = window.location.protocol + "//" + window.location.host;
  });

  $(".sendForm").click(function (event) {
    var host = window.location.port
      ? window.location.hostname + ":" + window.location.port
      : window.location.hostname;
    var id = $("form[id^='form-']").attr("id").split("-");
    var form_id = id[1];
    var url =
      window.location.protocol +
      "//" +
      host +
      "/gravityformsapi/forms/" +
      form_id +
      "/submissions";

    var goToNext = true;
    var emailValidate = true;
    if ($(".page.active .required:not(span):not(.hide)").length === 0) {
      goToNext = true;
    } else {
      var elements = $(".page.active .required:not(span):not(.hide)").find(
        "input, textarea, select"
      );
      $.each(elements, function (index, element) {
        if (
          element.type === "email" &&
          ($(element).val() === "" || !validateEmail($(element).val()))
        ) {
          emailValidate = false;
          goToNext = false;
          return false;
        }
        if (
          (element.type === "text" || element.type === "textarea") &&
          $(element).val() === ""
        ) {
          goToNext = false;
          return false;
        }
        if (
          element.type === "radio" &&
          $("input[name=" + element.name + "]:checked").length === 0
        ) {
          goToNext = false;
          return false;
        }
        if (element.type === "checkbox") {
          var min = 1;
          if ($(element).data("min") > 1) {
            min = $(element).data("min");
          }
          var sw = element.name.split("_");
          if (
            $("input[name^=" + sw[0] + "_" + sw[1] + "_]:checked").length < min
          ) {
            goToNext = false;
            return false;
          }
        }
      });
    }
    if (goToNext) {
      $(".page.active .error").addClass("hide");
      submitForm(url, form_id);
    } else {
      if (!emailValidate) {
        $(".page.active .error").html(
          "Bitte geben Sie eine gültige E-Mail-Adresse an."
        );
        $(".page.active .error").removeClass("hide");
      } else {
        $(".page.active .error").html(
          "Beantworten Sie alle Pflichtfragen, um fortzufahren."
        );
        $(".page.active .error").removeClass("hide");
      }
    }
  });

  function submitForm(url, form_id) {
    var formValues = $("#form-" + form_id).serializeArray();

    var inputValues = {};
    $.each(formValues, function (index, value) {
      var name = value.name;
      inputValues[name] = value.value;
    });

    var data = {
      input_values: inputValues,
    };
    $.ajax({
      url: url,
      type: "POST",
      data: JSON.stringify(data),
      beforeSend: function (xhr, opts) {},
    }).done(function (data, textStatus, xhr) {
      response = JSON.stringify(data.response, null, "\t");

      if (data.response.is_valid) {
        moveDown( true );
      }
    });
  }
})(jQuery);
